import { Tooltip } from '@sgme/ui';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import UserPreferencesModal from '@/App/UserPreferences/UserPreferencesModal.tsx';

const UserPreferences = () => {
  const { sgwtWebAnalytics } = useSgwtWidgets();
  const { formatMessage } = useIntl();
  const [showUserPreferences, setShowUserPeferences] = useState(false);

  const handleClose = () => {
    sgwtWebAnalytics?.trackEvent('Header', 'Close user preferences');
    setShowUserPeferences(false);
  };
  const handleShow = () => {
    sgwtWebAnalytics?.trackEvent('Header', 'Open user preferences');
    setShowUserPeferences(true);
  };

  return (
    <>
      <Tooltip contents={formatMessage({ id: 'userPreferences.Settings' })} position="bottom">
        <button
          type="button"
          className="h-100 btn btn-flat-primary btn-icon btn-nav btn-lg p-2"
          onClick={handleShow}
          data-e2e="user-preference-btn"
        >
          <i className="icon icon-md">settings</i>
        </button>
      </Tooltip>
      <UserPreferencesModal handleClose={handleClose} show={showUserPreferences} />
    </>
  );
};

export default UserPreferences;
